/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, {Component} from "react";
import "../css/Rules.css"
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography, withStyles
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar, Cell,
} from 'recharts';
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import PropTypes from "prop-types";
import ReferenceLine from "recharts/lib/cartesian/ReferenceLine";
import Label from "recharts/lib/component/Label";
import ResponsiveContainer from "recharts/lib/component/ResponsiveContainer";

const styles = theme => ({
  chipHigh: {
    fontSize: 16,
    backgroundColor: "#4caf50",
    colorPrimary:"#4caf50",
    margin: 5,
    color:"white",
  },
  chipHighBlack: {
    fontSize: 16,
    backgroundColor: "#000000",
    colorPrimary:"#000000",
    margin: 5,
    color:"white",
  },
  chipMedium: {
    fontSize: 16,
    backgroundColor: "#A4A4A4",
    margin: 5,
    color:"white",

  },
  chipLow: {
    fontSize: 16,
    backgroundColor: "#f4511e",
    margin: 5,
    color:"white",

  },
  avatarHigh:{
    backgroundColor: "#4caf50",
    color:"white",
  },
  avatarHighBlack:{
    backgroundColor: "#000000",
    color:"white",
  },
  avatarMedium:{
    backgroundColor: "#A4A4A4",
    color:"white",
  },
  avatarLow:{
    backgroundColor: "#f4511e",
    color:"white",

  },
  divContenedorOneComponent:{
    display:"flex",
    overflow:"auto",
    [theme.breakpoints.down("sm")]:{
      display: "block"
    }
  },
  divContenedorTwoComponent:{
    display:"flex",
    overflow:"auto",
    [theme.breakpoints.down("md")]:{
      display: "block"
    }
  },
  divContenedorThreeComponent:{
    display:"flex",
    overflow:"auto",
    [theme.breakpoints.down("lg")]:{
      display: "block"
    }
  },
  divContenedorFourComponent:{
    display:"flex",
    overflow:"auto",
    [theme.breakpoints.down("xl")]:{
      display: "block",
    }
  },
  contenedorChips:{
    listStyle:"none",
    float:"left",
    marginTop:"20px",
    padding:"15px",
  },
  tooltip:{
    backgroundColor: "white",
    opacity:0.2,
    borderColor:"grey",
  }
});
const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
        <div style={{backgroundColor:"white",opacity:0.5,border:"2px solid grey",fontSize:"20px"}}>
          <span> {"X:"+parseFloat(label).toFixed(2)} <ArrowRightAltIcon></ArrowRightAltIcon> {"Y:"+payload[0].value.toFixed(2)}</span>
        </div>
    );
  }

  return null;
};


export class Rules extends Component {
  constructor(props) {
    super(props);
    super(props);
    this.state = {};
  }


  /* example override */

  handleClose = (event, reason) => {
    this.setState({
      error: false,
      info: false,
      warning: false,
      success: false,
      tooltip:"none"
    });
  };
  render() {
    const { classes } = this.props;

    var config=[];
    var data =  new Array();
    var activatedSomeRule = false;
    for(var i=0;i<this.props.rules.consequents.length;i++) {
      config[i] ={color:this.props.rules.consequents[i].color};
      data[i] = {
        x:"Page "+this.props.rules.consequents[i].x,
        y:this.props.rules.consequents[i].y
      }
      if(this.props.rules.consequents[i].y >0){
        activatedSomeRule = true;
      }
    }
    return (
        <div style={{marginBottom:100}}>
          { activatedSomeRule &&
            <ResponsiveContainer width={"90%"} height={300}>
              <BarChart
                  data={this.props.rules.consequents}
                  margin={{
                    top: 5, bottom: 5,
                  }}
              >
                <CartesianGrid strokeDasharray="3 3"/>
                <XAxis dataKey="x"/>
                <YAxis/>
                <Tooltip formatter={(value) =>value.toFixed(5)} />
                <Bar dataKey="y" fill="#8884d8">{
                  data.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={config[index % config.length].color}/>
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          }
        {this.props.rules.rules.map((rule, index) => {
          var color = "black";
          var claseChip=classes.chipHighBlack, claseAvatar=classes.avatarHighBlack;
          var weigth = rule.activation > 0 ? "bold" : "normal";
          var activation = "(" + rule.activation.toFixed(2) + ")" ;
          var componentsActivations="";
          var tnorm = this.props.rules.product ? this.props.language.labels[this.props.language.id].producto:this.props.language.labels[this.props.language.id].minimo;
          rule.components.map((component)=>{
            return componentsActivations+=" "+component.activation.toFixed(2)+" ("+component.attribute+"), ";
          });

          var mensajeActivacion =
              rule.activation>0 ?
                  this.props.language.labels[this.props.language.id].messageActivation + rule.activation.toFixed(2)+this.props.language.labels[this.props.language.id].messageActivation2
                  + rule.cf.toFixed(2) + this.props.language.labels[this.props.language.id].messageActivation3 + tnorm + this.props.language.labels[this.props.language.id].messageActivation4 + componentsActivations.slice(0, -2) +"."
                  : "";
          if (
            rule.activation > 0 &&
            this.props.rules.state !== "unknown" &&
            rule.consequent.id === this.props.rules.correctSolution.id
          ) {
            color = "#4caf50";
            claseChip = classes.chipHigh;
            claseAvatar = classes.avatarHigh;
          } else if (
            rule.activation > 0 &&
            this.props.rules.state !== "unknown" &&
            rule.consequent.id !== this.props.rules.correctSolution.id
          ) {
            color = "#f4511e";
            claseChip = classes.chipLow;
            claseAvatar = classes.avatarLow;
          }else if(rule.activation <= 0){
            claseChip = classes.chipMedium;
            claseAvatar = classes.avatarMedium;
          }
          var tamanoMinimo = 120 + rule.components.length*375;
          var classNameNumber
          if(rule.components.length===1){
            classNameNumber= classes.divContenedorOneComponent;
          }else if(rule.components.length===2){
            classNameNumber= classes.divContenedorTwoComponent;
          }else if(rule.components.length===3){
            classNameNumber= classes.divContenedorThreeComponent;
          }else{
            classNameNumber= classes.divContenedorFourComponent;
          }
          return (
            <ExpansionPanel key={index}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  variant="h5"
                  style={{ color: color, fontWeight: weigth }}
                >
                  {this.props.language.labels[this.props.language.id].rule}{" "}
                  {index + 1} ::{" "}
                  {this.props.language.labels[this.props.language.id].class}{" "}
                  {rule.consequent.name} {activation}
                </Typography>
              </ExpansionPanelSummary>
              <div className={classNameNumber}>
                <div style={{display: "inherit",minWidth:tamanoMinimo,float:"left"}} >
                  <ul className={classes.contenedorChips}>
                    <li><Chip className={claseChip} label={rule.fd.toFixed(2)} size="big" avatar={<Avatar className={claseAvatar}>FD</Avatar>}/></li>
                    <li><Chip className={claseChip} label={rule.cf.toFixed(2)} size="big" avatar={<Avatar className={claseAvatar}>CF</Avatar>}/></li>
                    <li><Chip className={claseChip} label={rule.activation.toFixed(2)} size="big" avatar={<Avatar className={claseAvatar}>ACT</Avatar>}/></li>
                  </ul>
              <ExpansionPanelDetails
                ref={"rule" + index}
                style={{ overflow: "auto" }}
              >
                {rule.components.map(comp => {
                  var areaColors = ["#A4A4A4","black"];
                  if (
                    this.props.rules.state &&
                    this.props.rules.state !== "unknown" &&
                    this.props.rules.correctSolution.id === rule.consequent.id
                  ) {
                    areaColors = ["#A4A4A4", "green"];
                  } else if (
                    this.props.rules.state &&
                    this.props.rules.state !== "unknown"
                  ) {
                    areaColors = ["#A4A4A4", "red"];
                  }
                  debugger
                  if (comp.activationCoordinates.length === 4) {
                    var arrayCoordinates = new Array();
                    var flag=0;
                    for(var i=0;i<comp.activationCoordinates.length;i++){
                      if(comp.coordinates[i].x === comp.activationCoordinates[i].x) {
                        arrayCoordinates[i+flag] = comp.coordinates[i];
                        arrayCoordinates[i+flag]["z"] = comp.activationCoordinates[i].y;
                      }else{
                        if(comp.coordinates[i].x < comp.activationCoordinates[i].x) {
                          arrayCoordinates[i+flag] = comp.activationCoordinates[i];
                          arrayCoordinates[i+flag]["z"] = comp.activationCoordinates[i].y;
                          arrayCoordinates.splice(i+flag, 0, comp.coordinates[i]);
                          arrayCoordinates[i+flag]["z"] = comp.activationCoordinates[i].y;
                          flag++;
                        }else{
                          arrayCoordinates[i+flag] = comp.coordinates[i];
                          arrayCoordinates[i+flag]["z"] = comp.activationCoordinates[i].y;
                          arrayCoordinates.splice(i+flag, 0, comp.activationCoordinates[i]);
                          arrayCoordinates[i+flag]["z"] = comp.activationCoordinates[i].y;
                          flag++;
                        }
                      }
                    }

                    var mensajetoolTip1 = this.props.language.labels[this.props.language.id].messageToolTip + comp.activation.toFixed(2);
                    var mensajetoolTip2 = this.props.language.labels[this.props.language.id].messageToolTip2 + comp.id +"="+comp.value;
                    var idToolTip=comp.id+comp.activationCoordinates[0].x+ comp.activationCoordinates[1].x+ comp.activationCoordinates[2].x+ comp.activationCoordinates[3].x
                    var instanceValue = parseFloat(comp.value);
                    return (

                      <div>
                          <AreaChart
                              width={350}
                              height={200}
                              data={arrayCoordinates}
                              margin={{
                                top: 10, right: 30, left: 0, bottom: 0,
                              }}
                              formatter={(value) =>value.toFixed(5)}
                          >
                            <CartesianGrid formatter={(value) =>value.toFixed(5)} strokeDasharray="3 3" />
                            <XAxis dataKey="x"  type='number' domain={[comp.leftLimit.x,comp.rightLimit.x]} formatter={(value) =>value.toFixed(5)} >
                              <Label value={comp.attribute} offset={0} position="insideBottom" />
                            </XAxis>
                            <YAxis />
                            <Tooltip content={<CustomTooltip/>} />
                            <Area  formatter={(value) =>value.toFixed(5)} dataKey="y" fillOpacity="0.60"  stroke={areaColors[0]} fill={areaColors[0]} />
                            <Area  formatter={(value) =>value.toFixed(5)} dataKey="z" fillOpacity="0.60" stroke={areaColors[1]} fill={areaColors[1]} />
                            <ReferenceLine style={{color:"white"}} x={comp.value} stroke="white" label={"Instance value " + instanceValue.toFixed(2)} alwaysShow/>
                          </AreaChart>
                        </div>
                    );
                  } else {
                    debugger;
                    if(this.props.comprobation===1) {
                      if (comp.coordinates[0].x > comp.value) {
                        comp.coordinates.unshift({x: comp.value, y: 0});
                      } else if (comp.coordinates[comp.coordinates.length - 1].x < comp.value) {
                        comp.coordinates.push({x: comp.value, y: 0});
                      }
                    }
                    var mensajetoolTip1SA = this.props.language.labels[this.props.language.id].messageToolTip + comp.activation.toFixed(2);
                    var mensajetoolTip2SA = this.props.language.labels[this.props.language.id].messageToolTip2 + comp.id +"="+comp.value;
                    var idToolTipSA=comp.id+comp.value;
                    var instanceValue = parseFloat(comp.value);
                    debugger
                    return (
                        <div>
                            <AreaChart
                                width={350}
                                height={200}
                                data={comp.coordinates}
                                margin={{
                                  top: 10, right: 30, left: 0, bottom: 0,
                                }}
                                type='number'
                            >
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="x"  type='number' domain={[comp.leftLimit.x,comp.rightLimit.x]} >
                                <Label value={comp.attribute} offset={0} position="insideBottom" />
                              </XAxis>
                                <YAxis />
                              <Tooltip content={<CustomTooltip/>} />
                              <Area dataKey="y" fillOpacity="0.60" stroke={areaColors[0]} fill={areaColors[0]} />
                              {this.props.comprobation === 1  &&
                                <ReferenceLine x={comp.value} viewBox={true} stroke="black" label={"Instance value "+instanceValue.toFixed(2)} alwaysShow />
                              }
                            </AreaChart>
                        </div>
                    );
                  }
                })}
              </ExpansionPanelDetails>
                </div>

                {rule.activation>0 &&
                <div style={{float:"left"}}>
                  <p className={"textoExplicativoRules"}>{mensajeActivacion}</p>
                </div>
                }
              </div>
            </ExpansionPanel>
          );
        })}
      </div>
    );
  }
}
Rules.propTypes = {
  classes: PropTypes.object.isRequired
};
CustomTooltip.prototype = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Rules);
